import { GoogleDocEmbedError } from './GoogleDocEmbedError';
import { useEmbedLoadState } from './useEmbedLoadState';

export const EMBED_LOAD_TIMEOUT_MS = 8000;

type GoogleDocEmbedProps = {
  src: string;
  title: string;
  publishedUrl: string;
  forceError?: boolean;
};

export const GoogleDocEmbed = ({ src, title, publishedUrl, forceError = false }: GoogleDocEmbedProps) => {
  const { status, markLoaded } = useEmbedLoadState(src, EMBED_LOAD_TIMEOUT_MS);

  if (forceError || status === 'failed') {
    return <GoogleDocEmbedError publishedUrl={publishedUrl} />;
  }

  return (
    <iframe
      src={src}
      title={title}
      onLoad={markLoaded}
      className='h-[70vh] min-h-[420px] w-full lg:h-[640px] lg:min-h-0'
      style={{
        border: 'none',
        borderRadius: '8px',
        background: '#fff',
      }}
    />
  );
};
